var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visitor-survey__question" },
    [
      _c("visitor-survey-element", {
        attrs: {
          element: _vm.question.element,
          initial: _vm.getInitialDataForMain(),
          "validate-survey": _vm.validateSurvey,
        },
        on: { update: _vm.updateQuestion },
      }),
      _vm._v(" "),
      _vm.question.dependantQuestions.length > 0 &&
      _vm.hasSelectedMatchingOption &&
      _vm.matchingOptionElement &&
      _vm.matchingOptionElement.id &&
      _vm.matchingOptionElement.id > -1
        ? [
            _c("visitor-survey-element", {
              attrs: {
                element: _vm.matchingOptionElement,
                initial: _vm.getInitialDataForDependant(),
                "validate-survey": _vm.validateSurvey,
              },
              on: { update: _vm.updateDependantQuestion },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }